import { IconName } from '@fortawesome/fontawesome-svg-core';
import { BottomButton } from 'components/site/modals/SidebarModalWrapper/BottomButton';
import { EColors } from 'libs/styles/styling';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import styled from 'styled-components/macro';

interface ButtonProp {
    onClick: () => void;
    text: string;
    iconName: IconName;
}

interface Props {
    className?: string;
    buttons: ButtonProp[];
}

export const SidebarDefaultFooter = (props: Props) => {
    const isWide = useIsWide();

    return (
        <S_DetailFooter className={props.className}>
            {props.buttons.map((button) => (
                <S_BottomButton
                    key={button.text + button.iconName}
                    iconName={button.iconName}
                    text={button.text}
                    onClick={button.onClick}
                    darkText={isWide}
                />
            ))}
        </S_DetailFooter>
    );
};

const S_DetailFooter = styled.div`
    height: 75px;
    width: 100%;
    border-top: 1px solid ${EColors.BLACK3};
    background: #282727;
    box-shadow: inset 0px 5px 10px rgba(29, 29, 29, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-shrink: 0;
    padding: 0 0 0px 0;
    @media only screen and (min-width: 1260px) {
        box-shadow: 0px -4px 10px rgb(0 0 0 / 5%);
        background: #fafafa;
        border-top: 0px;
    }
`;

const S_BottomButton = styled(BottomButton)`
    width: 25%;
    height: 100%;
`;
